import firebase from '../../firebase.js';
const storage = firebase.storage();
const storageRef = storage.ref();
export default {
    name: 'editImages',
    data() {
        return {
            images: [],
            files: [],
            imgSource: '',
            imgCaption: '',
            addImageDialog: false,
            uploading: false
        };
    },
    props: ['originalImages'],
    methods: {
        addImage() {
            let image = {};
            image.editDialog = false;
            image.imageDialog = false;
            image.source = this.imgSource;
            image.caption = this.imgCaption;
            this.images.push(image);
            this.addImageDialog = false;
            this.imgSource = '';
            this.imgCaption = '';
        },
        filesChange(file) {
            this.files = file;
        },
        upload() {
            let imageRef = storageRef.child('images/' + this.files[0].name);
            this.uploading = true;
            imageRef.put(this.files[0]).then(
                function(snapshot) {
                    snapshot.ref.getDownloadURL().then(url => {
                        this.imgSource = url;
                        this.files = [];
                        this.$refs.fileUpload.value = null;
                        this.uploading = false;
                    });
                }.bind(this)
            );
        },
        removeImage(index) {
            this.images.splice(index, 1);
        }
    },
    mounted() {
        if (this.originalImages != null) {
            this.originalImages.forEach(d => {
                d.editDialog = false;
                d.imageDialog = false;
                this.images.push(d);
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/editImages/editImages.js